import React, {useContext, useEffect} from 'react'
import './Card.css';
import {playOpen} from "../../../utils/Sounds";
import {usePrevious} from "../../../utils/Hooks";
import {Context} from "../../App";

const Card = ({style, card, opacity = false}) => {
    const prevCard = usePrevious(card);
    const {soundsEnabled} = useContext(Context);

    useEffect(() => {
        if (soundsEnabled && card && prevCard !== card) playOpen();
    })

    if (!card) return null;

    let className = "Card ";
    className += style;
    if (opacity) className += " CardDisabled"; else className += " CardEnabled";

    const cardImage = require("../../../assets/Minicard_" + card + ".svg").default;
    return (<img className={className} src={cardImage} alt={card}/>);
}

export default Card;

